/* ============================================================
   eMedicalKits — Shared B2B JavaScript
   Handles: Quick Add to Cart, Quick Order Form, Cart badge updates
   ============================================================ */

(function () {
  'use strict';

  /* ── Quick Add to Cart (product card overlay button) ── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.emk-quick-add, .emk-ph-quick-add');
      if (!btn) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
          setTimeout(function () {
            btn.textContent = originalText;
          }, 2500);
        });
    });
  }

  /* ── Update cart badge count in nav ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.emk-cart-count');
        badges.forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ── Quick Order Form (Physician page) ── */
  function initQuickOrderForm() {
    var form = document.getElementById('emk-quick-order-form');
    if (!form) return;

    var rowsContainer = form.querySelector('.emk-ph-qo-rows');
    var addRowBtn = form.querySelector('.emk-ph-qo-add-row');
    var submitBtn = form.querySelector('.emk-ph-qo-submit');
    var messageEl = form.querySelector('.emk-ph-qo-message');

    /* Add a new empty row */
    if (addRowBtn) {
      addRowBtn.addEventListener('click', function () {
        addRow(rowsContainer);
      });
    }

    /* Remove row via delegated click */
    rowsContainer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.emk-ph-qo-remove');
      if (!removeBtn) return;
      var row = removeBtn.closest('.emk-ph-qo-row');
      if (rowsContainer.querySelectorAll('.emk-ph-qo-row').length > 1) {
        row.remove();
      }
    });

    /* Submit */
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      quickOrderSubmit(form, submitBtn, messageEl);
    });
  }

  function addRow(container) {
    var row = document.createElement('div');
    row.className = 'emk-ph-qo-row';
    row.innerHTML =
      '<input type="text" placeholder="SKU or Variant ID" class="emk-qo-sku" />' +
      '<input type="number" placeholder="Qty" min="1" value="1" class="emk-qo-qty" />' +
      '<button type="button" class="emk-ph-qo-remove" aria-label="Remove row">×</button>';
    container.appendChild(row);
  }

  function quickOrderSubmit(form, submitBtn, messageEl) {
    var rows = form.querySelectorAll('.emk-ph-qo-row');
    var lineItems = [];
    var hasInput = false;

    rows.forEach(function (row) {
      var skuInput = row.querySelector('.emk-qo-sku');
      var qtyInput = row.querySelector('.emk-qo-qty');
      var sku = skuInput ? skuInput.value.trim() : '';
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (sku) {
        hasInput = true;
        lineItems.push({ id: sku, quantity: qty });
      }
    });

    if (!hasInput) {
      showMessage(messageEl, 'Please enter at least one SKU or Variant ID.', 'error');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding to cart…';
    hideMessage(messageEl);

    /* Shopify requires numeric variant IDs. We attempt to parse each entry.
       If non-numeric, we surface an error for that SKU. */
    var validItems = [];
    var invalidSkus = [];

    lineItems.forEach(function (item) {
      var id = parseInt(item.id);
      if (!isNaN(id)) {
        validItems.push({ id: id, quantity: item.quantity });
      } else {
        invalidSkus.push(item.id);
      }
    });

    if (invalidSkus.length > 0) {
      showMessage(
        messageEl,
        'Could not find variant ID for: ' + invalidSkus.join(', ') +
          '. Please enter the numeric Shopify Variant ID.',
        'error'
      );
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add All to Cart';
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: validItems })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'One or more items could not be added.');
          });
        }
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        showMessage(messageEl, err.message || 'Error adding items. Please try again.', 'error');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add All to Cart';
      });
  }

  function showMessage(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'emk-ph-qo-message ' + type;
  }

  function hideMessage(el) {
    if (!el) return;
    el.className = 'emk-ph-qo-message';
    el.textContent = '';
  }

  /* ── Init on DOM ready ── */
  function init() {
    initQuickAdd();
    initQuickOrderForm();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
